import type { JsonValue } from "./types.js";

type ApiErrorPayload = { message?: string; error?: string } & Record<string, JsonValue | undefined>;
export type ApiError = Error & { payload?: ApiErrorPayload };

export const api = {
  async get<T>(url: string): Promise<T> {
    const response = await fetch(url, { credentials: "include" });
    return handle<T>(response);
  },
  async post<T>(url: string, body?: JsonValue): Promise<T> {
    const response = await fetch(url, {
      method: "POST",
      credentials: "include",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(body ?? {})
    });
    return handle<T>(response);
  },
  async patch<T>(url: string, body: JsonValue): Promise<T> {
    const response = await fetch(url, {
      method: "PATCH",
      credentials: "include",
      headers: { "content-type": "application/json" },
      body: JSON.stringify(body)
    });
    return handle<T>(response);
  },
  async delete<T>(url: string): Promise<T> {
    const response = await fetch(url, {
      method: "DELETE",
      credentials: "include"
    });
    return handle<T>(response);
  }
};

async function handle<T>(response: Response): Promise<T> {
  const payload = await response.json().catch(() => ({})) as ApiErrorPayload;
  if (!response.ok) {
    const error = new Error(payload.message ?? payload.error ?? `HTTP ${response.status}`) as ApiError;
    error.payload = payload;
    throw error;
  }
  return payload as T;
}
